import {
    LIST_POINT_SYSTEM_LOADING,
    LIST_POINT_SYSTEM_SUCCESS,
    LIST_POINT_SYSTEM_ERROR,
  } from "../../../constant/actionTypes";
  
  const listPointSystemReducer = (state = {}, action) => {
    switch (action.type) {
      case LIST_POINT_SYSTEM_LOADING: {
        let obj = {
          loading: true,
        };
        return obj;
      }
      case LIST_POINT_SYSTEM_SUCCESS: {
        let obj = {
          loading: false,
          data: action.response,
        };
        return obj;
      }
      case LIST_POINT_SYSTEM_ERROR: {
        let obj = {
          loading: false,
          status: action.response,
        };
        return obj;
      }
      default:
        return state;
    }
  };
  
  export default listPointSystemReducer;
  